const actionTypes = {
  InitializeOrder: 'INITIALIZE_ORDER',
  FetchAllShifts: 'FetchAllShifts',
  FetchAllCloseDates: 'FetchAllCloseDates',
};

export default actionTypes;
